<template>
  <section
    class="flex flex-col items-center justify-center border-2 border-ngray-6 rounded-lg p-4 min-w-[420px] min-h-[491px] gap-4 bg-ngray-8"
  >
    <h1 class="text-nred-3 text-[115px] font-extrabold leading-none">
      <slot name="heading">
        {{ "404" }}
      </slot>
    </h1>

    <h2 class="text-nblue-1 text-lg font-bold tracking-[5px] leading-[25px] px-5">
      <slot name="subHeading">
        {{ $t("errors.pages.404.title") }}
      </slot>
    </h2>

    <p class="text-sm font-normal text-nblue-1 w-[230px] text-center">
      <slot name="description">
        {{ $t("errors.pages.404.message") }}
      </slot>
    </p>
    <slot name="actions">
      <button
        class="text-ngray-8 bg-nblue-1 cursor-pointer rounded-full px-6 py-3 font-semibold text-center"
        @click="$attrs.onBack ? $emit('back') : $router.back()"
      >
        <slot name="actionText">
          {{ $t("buttons.goBack") }}
        </slot>
      </button>
    </slot>
    <slot />
  </section>
</template>
